import React, { useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { nanoid } from 'nanoid';

import { closeDialogAction, openDialogAction, showMessageAction } from 'store/global/actions';

import CicEditReasonForm from '../components/CicEditReasonForm';
import { EDIT_REASON_DIALOG_HEADER } from '../components/CicEditReasonForm/CicEditReasonForm.constants';
import { EDIT_REASON_DIALOG_SIZE, REASON_UPDATED_MESSAGE } from '../LoanCicHistory.constants';

/** Opens the Edit CIC reason dialog for a pending field or fee change; refreshes the history after a save or a 409. */
export const useOpenCicEditReasonModal = ({ onHistoryChanged }) => {
  const dispatch = useDispatch();

  const modalIdRef = useRef(null);

  const closeModal = useCallback(() => dispatch(closeDialogAction(modalIdRef.current)), [dispatch]);

  const onSaved = useCallback(() => {
    closeModal();
    dispatch(showMessageAction({ message: REASON_UPDATED_MESSAGE, variant: 'success' }));
    onHistoryChanged();
  }, [closeModal, dispatch, onHistoryChanged]);

  return useCallback(
    ({ change, bundleType, plannedTriggerDate, isFeeChange = false }) => {
      modalIdRef.current = nanoid();

      dispatch(
        openDialogAction({
          id: modalIdRef.current,
          header: EDIT_REASON_DIALOG_HEADER,
          isRestyled: true,
          size: EDIT_REASON_DIALOG_SIZE,
          body: () => (
            <CicEditReasonForm
              bundleType={bundleType}
              change={change}
              isFeeChange={isFeeChange}
              plannedTriggerDate={plannedTriggerDate}
              onCancel={closeModal}
              onConflict={onHistoryChanged}
              onSaved={onSaved}
            />
          ),
        }),
      );
    },
    [dispatch, closeModal, onHistoryChanged, onSaved],
  );
};
